export const MainBox = {
  minHeight: "400px",
  minWidth: "400px",
};
